export default __webpack_public_path__ + "static/media/IMG_0844.18ec2e1d.jpeg";